<ng-container *ngIf="loading">
  <gen-overlay-loader></gen-overlay-loader>
</ng-container>
<gen-dynamic-form
  [formConfig]="config"
  [formName]="fromId"
  [stayInFormMode]="true"
  [disabled] = "widgetDisabledStatus"
  [editMode]="isEditMode"
  [listenToDataChange]="listenToDataChange"
  [submitted]="widgetFormInstanceSubmitted"
  (formChange) = "updatePractitionerObject($event.form)"
  (validateChange)="validateChangeEvent($event)"
  [resetForm]="restForm"
  [formData]="data">
</gen-dynamic-form>

<section class="actions-container" *ngIf="showEditButton && isEditMode && controls">
  <gen-button
    *ngFor="let control of controls"
    [text]="control.name"
    [type]="control.btnType? control.btnType : 'primary'"
    [iconClass]="control.iconClass"
    (click)="buttonClick(control.type)">
  </gen-button>
</section>

<section class="actions-container-edit" *ngIf="showEditButton && !isEditMode && !isNewPractitioner">
  <gen-button
    [text]="'Edit'"
    [type]="'primary'"
    (click)="buttonClick('edit')">
  </gen-button>
</section>

<section class="actions-container-edit" *ngIf="showEditButton && !isEditMode && isNewPractitioner">
  <gen-button
    [text]="'Save'"
    [type]="'primary'"
    (click)="buttonClick('submit')">
  </gen-button>
</section>
